import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UcatLayout } from "../../Components/Shared";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import { listReViewExamID } from "../../../../Redux/Slices/ReViewExam/ListReViewExamSlice";
import { listReViewExamIDPractice } from "../../../../Redux/Slices/ReViewExamPractice/ListReViewExamPracticeSlice";
import { listEvaluation } from "../../../../Redux/Slices/Exam/ListEvaluationSlice";
import { listEvaluationPractice } from "../../../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import { CircularProgress } from "@mui/material";
import { ReactComponent as Logo } from "../../../../.MODULS/UCAT_EXAM_MODUL/Assests/download-min.svg";
import useNavigationBlocker from "../../../../Hooks/useNavigationBlocker";
import { ClosedCaptionDisabledSharp } from "@mui/icons-material";

export const TestSummaryScreen: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const state = location.state as any;

    // Persist state to handle reloads
    useEffect(() => {
        if (state && typeof state === 'object') {
            sessionStorage.setItem("ucat_summary_state", JSON.stringify(state));
        }
    }, [state]);

    const persistedStateStr = sessionStorage.getItem("ucat_summary_state");
    const persistedState = persistedStateStr ? JSON.parse(persistedStateStr) : null;
    const activeState = (state && typeof state === 'object') ? state : persistedState;
    const { studentExamId, fromResultScreen, evalAs, showBackButton, customBackPath } = activeState || {};

    useNavigationBlocker(!showBackButton && !customBackPath);
    console.log("TSS_EVAL_AS", evalAs);

    const { data: listReViewExamIDSlice, isLoading: LoadingReview } = useAppSelector(
        (state) => state.ListReViewExamIDSlice || {}
    );

    const { data: listReViewExamPracticeSlice, isLoading: LoadingReviewPractice } = useAppSelector(
        (state: any) => state.ListReViewExamIDPracticeSlice || {}
    );

    const { data: listEvaluationSlice, isLoading: LoadingEval } = useAppSelector(
        (state) => state.ListEvaluationSlice || {}
    );

    const { data: listEvaluationPracticeSlice, isLoading: LoadingEvalPractice } = useAppSelector(
        (state) => state.ListEvaluationPracticeSlice || {}
    );

    const evaluationTriggered = React.useRef(false);
    const [evalLoadHasStarted, setEvalLoadHasStarted] = React.useState(false);

    useEffect(() => {
        if (studentExamId && !evaluationTriggered.current) {
            console.log("📊 Starting evaluation for ID:", studentExamId);
            if (evalAs === "exam") {
                dispatch(listEvaluation({ student_exam_id: studentExamId }));
            } else {
                dispatch(listEvaluationPractice({ student_test_id: studentExamId }));
            }
            evaluationTriggered.current = true;
        }
    }, [dispatch, studentExamId, evalAs]);

    useEffect(() => {
        if (LoadingEvalPractice === true || LoadingEval === true) {
            setEvalLoadHasStarted(true);
        }
    }, [LoadingEvalPractice, LoadingEval]);

    useEffect(() => {
        // Only trigger Review if evaluation has successfully finished
        const hasEvalData = evalAs === "exam"
            ? listEvaluationSlice && (Array.isArray(listEvaluationSlice) ? listEvaluationSlice.length > 0 : !!listEvaluationSlice)
            : listEvaluationPracticeSlice && (Array.isArray(listEvaluationPracticeSlice) ? listEvaluationPracticeSlice.length > 0 : !!listEvaluationPracticeSlice);

        const isLoading = evalAs === "exam" ? LoadingEval : LoadingEvalPractice;
        const hasReviewData = evalAs === "exam" ? listReViewExamIDSlice : listReViewExamPracticeSlice;
        const isReviewLoading = evalAs === "exam" ? LoadingReview : LoadingReviewPractice;

        if (studentExamId && evaluationTriggered.current && isLoading === false && hasEvalData && !hasReviewData?.data && !isReviewLoading) {
            console.log("✅ Evaluation successful/ready, now fetching review data for id:", studentExamId, "evalAs:", evalAs);
            if (evalAs === "exam") {
                dispatch(listReViewExamID({ id: studentExamId }));
            } else {
                dispatch(listReViewExamIDPractice({ id: studentExamId }));
            }
        }
    }, [dispatch, studentExamId, LoadingEval, LoadingEvalPractice, listEvaluationSlice, listEvaluationPracticeSlice, listReViewExamIDSlice, listReViewExamPracticeSlice, LoadingReview, LoadingReviewPractice, evalLoadHasStarted, evalAs]);

    const findQuestionsLine = (obj: any): any[] => {
        if (!obj) return [];
        if (Array.isArray(obj)) {
            if (obj[0]?.questions_line) return obj[0].questions_line;
            if (obj.length > 0 && obj[0]?.question_id) return obj;
            return [];
        }
        if (obj.questions_line) return obj.questions_line;
        if (obj.data?.questions_line) return obj.data.questions_line;
        if (obj.data) {
            if (Array.isArray(obj.data)) return obj.data[0]?.questions_line || [];
            if (obj.data.questions_line) return obj.data.questions_line;
            return findQuestionsLine(obj.data);
        }
        return [];
    };

    const evalLinesMock = findQuestionsLine(listEvaluationSlice);
    const evalLinesPractice = findQuestionsLine(listEvaluationPracticeSlice);
    const evaluationLines = evalLinesMock.length > 0 ? evalLinesMock : evalLinesPractice;

    const evaluationMap = new Map();
    evaluationLines.forEach((item: any) => {
        evaluationMap.set(Number(item.question_id), item);
    });

    const reviewDataRaw = evalAs === "exam"
        ? listReViewExamIDSlice?.data || listReViewExamIDSlice
        : listReViewExamPracticeSlice?.data || listReViewExamPracticeSlice;
    const reviewData: any = reviewDataRaw;
    const allQuestions = reviewData?.questions || [];
    console.log("allQuestions", allQuestions);
    const questionsByType: Record<string, any[]> = {};
    allQuestions.forEach((q: any) => {
        const typeName = (q.question_type_name ?? q.Question_type_name) || "General";
        if (!questionsByType[typeName]) {
            questionsByType[typeName] = [];
        }
        questionsByType[typeName].push(q);
    });

    const summData = evalAs == "exam"
        ? (listEvaluationSlice as any)?.data?.question_type_details
        : (listEvaluationPracticeSlice as any)?.data?.question_type_details;

    // Use API data directly if available, otherwise fall back to manual calculation
    const summaryData = summData && Array.isArray(summData) ? summData.map((item: any) => ({
        name: item.question_type_name || item.section_name,
        correct: item.total_correct || item.correct_answers,
        total: item.total_count || item.total_questions
    })) : Object.entries(questionsByType).map(([typeName, questions]) => {
        const correctCount = questions.filter((q: any) => {
            const chosenOption = q.options?.find((opt: any) => opt.chosen);
            const evalItem = evaluationMap.get(Number(q.question_id));
            const hasTime = evalItem && Number(evalItem.time_taken_seconds) > 0;
            return hasTime && chosenOption?.is_correct;
        }).length;
        console.log("Correct count for", typeName, ":", correctCount)

        return {
            name: typeName,
            correct: correctCount,
            total: questions.length
        };
    });

    const handleNext = () => {
        // If fromResultScreen is true, we just go back to where we came from (Result Screen)
        // Otherwise we proceed to the Result Screen as the normal flow
        navigate("/ucat_examresult_practice", { state: { ...location.state, fromResultScreen: undefined } });
    };
    console.log("SDSD", summaryData, summData)

    const isLoading = LoadingReview || LoadingReviewPractice || LoadingEval || LoadingEvalPractice;

    return (
        <UcatLayout
            headerTitle={reviewData?.exam_name || "UCAT Practice"}
            showToolbar={true}
            isLoading={isLoading}
            footerProps={{
                onNext: customBackPath ? () => navigate(customBackPath) : (showBackButton ? () => navigate(-1) : handleNext),
                rightButtonText: (showBackButton || customBackPath) ? "Back" : (fromResultScreen ? "Return to Review Screen" : "Next"),
                leftButtonText: ""
            }}
        >
            <div className="flex-1 h-0 min-h-0 w-full overflow-y-auto ucat-scrollbar bg-white">
                <div className="flex flex-col items-center py-4 px-6 w-full mx-auto">
                    {/* ... (Logo and Headers remain same) ... */}
                    {/* Logo */}
                    <div className="w-full h-[150px] flex justify-center mb-4">
                        <Logo className="w-[456px] h-auto" />
                    </div>

                    <div className="w-full text-center space-y-1 mb-2">
                        <h1 className="text-[16px] font-bold text-gray-900 leading-tight">UCAT Practice Test</h1>
                    </div>
                    <div className="w-full text-left space-y-1 mb-2">
                        <h2 className="text-[15px] font-bold text-gray-800">Summary Score Screen</h2>
                    </div>

                    {isLoading ? (
                        <div className="flex flex-col items-center justify-center py-20 w-full">
                            <CircularProgress />
                            <p className="mt-4 text-gray-600 font-medium">Calculating your final score...</p>
                        </div>
                    ) : (
                        <div className="w-full text-[15px]">
                            <div className="w-full space-y-4 text-[15px] text-black mb-8 leading-[1.35]">
                                <p className="text-[15px] font-[400] ">You will not see this screen in the live exam.</p>
                                <p className="text-[15px] font-[400]">
                                    This screen is provided to help you understand how well you have done in the practice test. Some questions in Decision Making and the Situational Judgement Test use partial marking. Please note this screen only reports those questions you have answered fully correctly.
                                </p>
                                <p className="text-[15px] font-[700]">
                                    Number of correctly answered questions for each of the subtests:
                                </p>
                            </div>

                            <table className="w-full max-w-5xl mt-6 mb-10 font-[Arial] bg-white border-none">
                                <thead>
                                    <tr>
                                        <th className="py-2 px-4 text-left text-[15px] font-bold text-black w-1/3 bg-white border-none">
                                            Section
                                        </th>
                                        <th className="py-2 px-4 text-center text-[15px] font-bold text-black bg-white border-none">
                                            Correct<br />Answers
                                        </th>
                                        <th className="py-2 px-4 text-center text-[15px] font-bold text-black bg-white border-none">
                                            Number of<br />Questions
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {summaryData?.map((row: any, idx: number) => (
                                        <tr key={idx}>
                                            <td className="py-3 px-4 text-[15px] font-bold text-black bg-white border-none">
                                                {row.name}
                                            </td>
                                            <td className="py-3 px-4 text-[15px] text-center text-black bg-white border-none">
                                                {row.correct || 0}
                                            </td>
                                            <td className="py-3 px-4 text-[15px] text-center text-black bg-white border-none">
                                                {row.total}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                            <p className="w-full text-[15px] text-black  mt-4">
                                {(showBackButton || customBackPath) ? (
                                    <>
                                        Click the <span className="font-bold" style={{ fontSize: "inherit" }}>Back</span> button to return.
                                    </>
                                ) : fromResultScreen ? (
                                    <>
                                        Click the <span className="font-bold" style={{ fontSize: "inherit" }}>Return to Review Screen</span> button to go back.
                                    </>
                                ) : (
                                    <>
                                        Click the <span className="font-bold" style={{ fontSize: "inherit" }}>Next (N)</span> button to proceed to the Item Review screen.
                                    </>
                                )}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </UcatLayout>
    );
};

export default TestSummaryScreen;
